import { render, staticRenderFns } from "./Models.vue?vue&type=template&id=1ae585f4&scoped=true"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"
import style0 from "./Models.vue?vue&type=style&index=0&id=1ae585f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae585f4",
  null
  
)

export default component.exports